import Onboarding1 from "../../components/Onboarding1";

export default function OnboardingPage1() {
    return (
        <Onboarding1 />
    )
};